module.exports = __webpack_public_path__ + "static/media/answerDefault.46654876.svg";